import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PartnerCategoriesRoutes: Routes = [
  {
    path: "partner-categories",
    loadComponent: () =>
      import("./partner-category/partner-category.component").then(
        (m) => m.PartnerCategoryComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./partner-category-list/partner-category-list.component").then(
            (m) => m.PartnerCategoryListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./partner-category-form/partner-category-form.component").then(
            (m) => m.PartnerCategoryFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./partner-category-form/partner-category-form.component").then(
            (m) => m.PartnerCategoryFormComponent,
          ),
      },
    ],
  },
];
